/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Guide_How_It_Works_Step_TwoInputs */

const en_directory_guide_how_it_works_step_two = /** @type {(inputs: Directory_Guide_How_It_Works_Step_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editors review the listing for product quality and directory fit.`)
};

const zh_directory_guide_how_it_works_step_two = /** @type {(inputs: Directory_Guide_How_It_Works_Step_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑会审核产品质量以及是否适合收录到目录。`)
};

/**
* | output |
* | --- |
* | "Editors review the listing for product quality and directory fit." |
*
* @param {Directory_Guide_How_It_Works_Step_TwoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_guide_how_it_works_step_two = /** @type {((inputs?: Directory_Guide_How_It_Works_Step_TwoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Guide_How_It_Works_Step_TwoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_guide_how_it_works_step_two(inputs)
	return zh_directory_guide_how_it_works_step_two(inputs)
});
export { directory_guide_how_it_works_step_two as "directory.guide.how_it_works.step_two" }